@if (titleIcon && fallbackIcon) {
    <div class="title-icon">
        @if (titleLogo && leagueId) {
            <ms-competition-logo class="icon" [sportId]="sportId" [leagueId]="leagueId" [fallbackIcon]="fallbackIcon" />
        } @else if (fallbackIcon) {
            <span class="icon" [ngClass]="fallbackIcon"></span>
        }
    </div>
}

@if (title) {
    <div class="title" [title]="title">{{ title }}</div>
}

@if (linkConfig && linkConfig.link && (linkConfig.linkText || linkConfig.disableLinkTextAndClick)) {
    <div class="globalLink">
        <ms-item [href]="linkConfig.link" [tracking]="undefined" (click)="!linkConfig.disableLinkTextAndClick && linkClicked()">
            @if (linkConfig.linkText && !linkConfig.disableLinkTextAndClick) {
                <span item-title [innerHtml]="linkConfig.linkText | msTrust: 'html'"></span>
            }
        </ms-item>
    </div>
}
<ng-content />
